module.exports = __webpack_public_path__ + "static/media/ultimate_party_pack_french_128.f4fc90ba.png";